import type { CMSContent } from '@/core';
import type { CMSContentWithLocalization } from '@/model';

export const localizeContentResponse = <T>(objectResponse: CMSContentWithLocalization<T>): CMSContent<T> => {
  if (objectResponse.localization) {
    objectResponse.content = { ...objectResponse.content, ...objectResponse.localization };
  }
  return objectResponse;
};
